<div class="row flex gap-3" style="justify-content: center;">
    <div class="mt-2" style="display: flex; justify-content: center;  flex-wrap: wrap; width: {{widthPx}}px;">
        <h6 class="text-primary" i18n="@@">Signature</h6>
        <canvas #myCanvasSignature style="background-color:whitesmoke; border:solid 1px black; " width="{{widthPx}}"
            height="{{heightPx}}"></canvas>
        <div  class="mt-2 w-100">
            <button class="btn btn-soft-danger w-100" (click)="clearSig()">Clear</button>
        </div>
    </div>
    <div class="mt-2" style="display: flex; justify-content: center;  flex-wrap: wrap; width: {{widthPx}}px;">
        <h6 class="text-primary" i18n="@@">Initials</h6>
        <canvas #myCanvasInitials style="background-color:whitesmoke; border:solid 1px black; " width="{{widthPx}}"
            height="{{heightPx}}"></canvas>
        <div class="mt-2 w-100">
            <button class="btn btn-soft-danger w-100" (click)="clearInit()">Clear</button>
        </div>
    </div>
</div>

<div class="justify-content-center" style="display: flex;">
    <div class="col-lg-6">
        <div class="mt-4">
            <button class="btn btn-success w-100" type="submit" i18n="@@" (click)="save()">Submit
                Signature</button>
        </div>
        <div class="mt-2">
            <div style="display:flex; flex-wrap: wrap;justify-content: space-around;">
                <p class="mb-0 fs-12 text-muted fst-italic" i18n="@@">By signing and submitting your signature, you
                    agree to MyFile's
                </p> <a href="https://myfile.ca/terms-conditions"
                    class="text-primary text-decoration-underline fst-normal fw-medium "
                    i18n="@@Link_TermsAndConditions">Terms and Conditions</a>
            </div>

        </div>
    </div>
</div>